module.exports = __webpack_public_path__ + "img/hungaria-footer.bf684fc1.svg";